import React from 'react';
import { useLocation, useNavigate } from 'react-router';

import Button from '~/components/button';
import Modal from '~/components/modals/modal';
import { newLawnRoute, newPestRoute } from '~/routes';

import styles from '~/components/modals/modal.module.scss';

const SomethingsNotRightModal = ({ isOpen, onClose, route }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isPestFunnel = location.pathname === newPestRoute();

  const titleText = isPestFunnel ? `It’s all good!` : `Let’s fix it`;
  const bodyText = isPestFunnel ? (
    <>
      If the image of your property is incorrect, don't worry! We've got plenty
      of data to work with based on your <strong>zip code</strong>.
    </>
  ) : (
    <>
      We gather data based on <strong>your address</strong> and{' '}
      <strong>geographic location</strong>. If the image of your property is
      incorrect, don’t worry! As long as you input the number of square feet you
      want treated, we will take care of the rest.
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={styles.somethingsNotRightModal}
    >
      <h1>{titleText}</h1>
      <p>{bodyText}</p>
      <Button fullWidth onClick={onClose}>
        Got it
      </Button>
      <Button
        fullWidth
        variant="link"
        onClick={() => {
          navigate(route ?? newLawnRoute(), { replace: true });
          onClose();
        }}
      >
        Start over with a new address
      </Button>
    </Modal>
  );
};

export default SomethingsNotRightModal;
